import { ProjectTypeActions } from "./project-type.actions";
import { projectTypeAdapter } from "./project-type.state";
import { initialProjectTypeState } from "./project-type.state";
import { createReducer, on } from "@ngrx/store";

export const projectTypeReducer = createReducer(
    initialProjectTypeState,
    on(ProjectTypeActions.loadProjectTypeSuccess, (state, action) => {
        return projectTypeAdapter.setAll(action.projectTypes, {
            ...state,
            errorMessage: null
        });
    }),
    on(ProjectTypeActions.addProjectTypeSuccess, (state, { projectType }) => {
        return projectTypeAdapter.addOne(projectType, {
            ...state,
            errorMessage: null
        });
    }),
    on(ProjectTypeActions.updateProjectTypeSuccess, (state, { projectType }) => {
        if (!projectType.projectTypeId) {
            return {
                ...state,
                errorMessage: "projectTypeId is required for update"
            };
        }
        return projectTypeAdapter.updateOne({ id: projectType.projectTypeId, changes: projectType }, {
            ...state,
            errorMessage: null
        });
    }),
    on(ProjectTypeActions.deleteProjectType, (state, { projectTypeId }) => {
        return projectTypeAdapter.removeOne(projectTypeId, {
            ...state,
            errorMessage: null
        });
    }),
);